import _taggedTemplateLiteral from "/home/vsts/work/1/s/Office.Planner.Website/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n    font-size: 0.875rem;\n    font-weight: 400;\n    line-height: 1.75;\n  "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n      font-size: 0.875rem;\n      font-weight: 600;\n    "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n      font-size: 0.8125rem;\n      font-weight: 400;\n    "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n      font-size: 1rem;\n      font-weight: 500;\n    "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n      font-size: 1.125rem;\n      font-weight: 500;\n      font-family: 'Poppins', sans-serif;\n    "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n      font-size: 1.375rem;\n      font-weight: 600;\n      font-family: 'Poppins', sans-serif;\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  color: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import { jsx as _jsx } from "react/jsx-runtime";
import styled, { css } from 'styled-components';
var StyledText = styled.span(_templateObject(), function (props) {
  return props.font;
}, function (props) {
  return props.appearance === 'default' ? props.theme.colors.foreground : props.appearance === 'secondary' ? props.theme.colors.accent8 : props.appearance === 'faded' ? props.theme.colors.accent6 : props.theme.colors[props.appearance];
});

function getElementTag(_ref) {
  var p = _ref.p,
      h1 = _ref.h1,
      h2 = _ref.h2,
      h3 = _ref.h3;

  if (p) {
    return 'p';
  }

  if (h1) {
    return 'h1';
  }

  if (h2) {
    return 'h2';
  }

  if (h3) {
    return 'h3';
  }

  return 'span';
}

function getFont(_ref2) {
  var h1 = _ref2.h1,
      h2 = _ref2.h2,
      h3 = _ref2.h3,
      small = _ref2.small,
      b = _ref2.b;

  if (h1) {
    return css(_templateObject2());
  }

  if (h2) {
    return css(_templateObject3());
  }

  if (h3) {
    return css(_templateObject4());
  }

  if (small) {
    return css(_templateObject5());
  }

  if (b) {
    return css(_templateObject6());
  }

  return css(_templateObject7());
}

function Text(_a) {
  var children = _a.children,
      p = _a.p,
      h1 = _a.h1,
      h2 = _a.h2,
      h3 = _a.h3,
      small = _a.small,
      b = _a.b,
      as = _a.as,
      _a$appearance = _a.appearance,
      appearance = _a$appearance === void 0 ? 'default' : _a$appearance,
      rest = __rest(_a, ["children", "p", "h1", "h2", "h3", "small", "b", "as", "appearance"]);

  var tags = {
    p: p,
    h1: h1,
    h2: h2,
    h3: h3,
    small: small,
    b: b
  };
  return _jsx(StyledText, Object.assign({
    as: as || getElementTag(tags),
    font: getFont(tags),
    appearance: appearance
  }, rest, {
    children: children
  }), void 0);
}

export default Text;